<template>
  <b-button
    variant="primary"
    class="badge badge-pill my-1 mr-2 text-capitalize"
    :class="{ active: isActive }"
    @click="handleClick"
  >
    <slot />
  </b-button>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'

export default defineComponent({
  name: 'BDXStatusModalFiltersButton',
  props: {
    value: String,
    nativeValue: String
  },
  emits: ['input'],
  setup(props, { emit }) {
    const isActive = computed(() => props.value === props.nativeValue)

    const handleClick = () =>
      emit('input', isActive.value ? undefined : props.nativeValue)

    return {
      isActive,

      handleClick
    }
  }
})
</script>
